import React from 'react';
import PhoneInput from 'react-phone-input-2';
import Select from 'react-select';
import utils from 'helpers/utils';
import constants from 'helpers/const';
import 'react-phone-input-2/lib/bootstrap.css';

const HOST = window.location.host;

function Error({ message }) {
  return (
    <p
      style={{
        color: '#f44336',
        margin: '4px .75rem',
        fontSize: '0.7rem',
      }}
    >
      {message}
    </p>
  );
}

export class PublicLink extends React.Component {
  constructor(props) {
    super(props);
    this.refPrefix = React.createRef();
    this.state = {
      prefixWidth: 100,
      labelBtnCopy: 'Copy',
    };
  }

  componentDidMount() {
    const prefix = this.refPrefix.current;
    if (prefix) {
      this.setState({ prefixWidth: prefix.offsetWidth });
    }
  }

  copyPublicLink = () => {
    const { input } = this.props;
    this.setState({ labelBtnCopy: 'Copied' });
    utils.copyToClipboard(`${HOST}${utils.getPublicProfilePathname(input.value)}`);
    setTimeout(() => {
      this.setState({ labelBtnCopy: 'Copy' });
    }, 1000);
  };

  render() {
    const {
      input,
      label,
      type,
      meta: { touched, error },
      disabled,
    } = this.props;
    const { prefixWidth, labelBtnCopy } = this.state;
    return (
      <div className="form-item public-link col-12">
        <span className="label d-block mt-3 mb-2">
          {label} {touched && error && <small className="error">{error}</small>}
        </span>
        <div className="input-container">
          <span ref={this.refPrefix} className="prefix">
            {HOST}
            {constants.PREFIX_PROFILE_PATHNAME}
          </span>
          <input
            style={{ paddingLeft: prefixWidth }}
            {...input}
            disabled={disabled}
            className="w-100 form-control"
            type={type}
            placeholder="your.public.name"
          />
          <button disabled={labelBtnCopy === 'Copied'} type="button" className="btn-copy" onClick={this.copyPublicLink}>
            {labelBtnCopy}
          </button>
        </div>
      </div>
    );
  }
}

export class IntlPhoneInput extends React.Component {
  onPhoneInputChange = (value, data, event) => {
    const { input } = this.props;
    const rawNumber = value.replace(/[^0-9+]/g, '').trim();
    input.onChange({ ...data, number: rawNumber }, event);
  };

  render() {
    const {
      input: { value, onChange, onBlur, ...input },
      label,
      meta: { touched, error },
      disabled,
    } = this.props;
    return (
      <div className="form-item col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
        <span className="label d-block mt-3 mb-2">
          {label} {touched && error && <small className="error">{error}</small>}
        </span>
        <PhoneInput
          enableSearch={true}
          disabled={disabled}
          inputStyle={{ paddingLeft: 58 }}
          searchStyle={{ width: '100%' }}
          inputProps={{
            ...input,
            className: 'w-100 form-control',
          }}
          value={value.number}
          onChange={this.onPhoneInputChange}
        />
      </div>
    );
  }
}

export function TextField({ input, label, meta: { touched, error }, containerProps, style, ...props }) {
  return (
    <div {...containerProps}>
      {label && <h4>{label}</h4>}
      <input className="form-control w-100" {...input} {...props} style={{ borderRadius: 8, ...style }} />
      {touched && error && <Error message={error} />}
    </div>
  );
}

const customSelectStyles = {
  control: (_, { selectProps: { isDisabled } }) => {
    return {
      background: isDisabled ? '#e9ecef' : '#FFF',
      borderRadius: 8,
      display: 'flex',
      border: '1px solid #cfcfcf',
    };
  },
};

export function SelectField({
  label,
  input,
  options,
  disabled,
  selectProps,
  meta: { touched, error },
  containerProps,
}) {
  return (
    <div {...containerProps}>
      {label && <span className="label d-block mt-3 mb-2">{label}</span>}
      <Select
        {...input}
        {...selectProps}
        styles={customSelectStyles}
        isDisabled={disabled}
        className="w-100"
        onChange={(value) => input.onChange(value)}
        onBlur={(event) => event.preventDefault()}
        options={options}
        isClearable={false}
        components={{
          DropdownIndicator: null,
        }}
      />
      {touched && error && <Error message={error} />}
    </div>
  );
}

export function CheckBoxField({ id, input, label, ...props }) {
  return (
    <label className="checkbox-wrapper" htmlFor={id}>
      <span>{label}</span>
      <input id={id} type="checkbox" checked={!!input.value} {...input} {...props} />
      <span className="checkmark"></span>
    </label>
  );
}
